module.exports = __webpack_public_path__ + "static/img/describe_img.4e0848a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/describe_img.png
// module id = pZVD
// module chunks = 1